module.exports = __webpack_public_path__ + "static/media/info_round.6e203f9e.svg";